<template>
  <v-menu :close-on-content-click="false" bottom offset-y>
    <template v-slot:activator="{ on: onMenu }">
      <v-avatar class="avatar" v-on="onMenu">
        <v-tooltip bottom>
          <template #activator="{ on: onTooltip }">
            <span v-on="{ ...onMenu, ...onTooltip }" class="white--text" :class="{ headline: !showUserIcon }">
              <template v-if="showUserIcon">
                <v-icon color="white">fas fa-user</v-icon>
              </template>
              <template v-else>
                {{ firstLetter }}
              </template>
            </span>
          </template>
          <div class="boldText">{{ $t("My Account") }}</div>
          <div>{{ name }}</div>
          <div>{{ email }}</div>
        </v-tooltip>
      </v-avatar>
    </template>
    <v-carousel
      height="auto"
      hide-delimiters
      :continuous="false"
      light
      touchless
      v-model="screenChange"
      :show-arrows="false"
      width="300"
      color="white"
      class="carousel"
    >
      <v-carousel-item>
        <v-list class="pa-2 myaccount-list" width="300">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ name }}</v-list-item-title>
              <v-list-item-subtitle>{{ email }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="additionalData"
                >{{ $t(additionalData.title) }} :
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ additionalData.value }}</span> </template
                  ><span>{{ additionalData.value }}</span></v-tooltip
                ></v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
          <v-divider class="ma-4"></v-divider>
          <v-list-item v-if="!supportAccess" v-show="showMyAccount" class="menu-link">
            <v-list-item-content>
              <v-list-item-title>
                <a class="no-decoration text--text mr-5" :href="myAccountURL" target="_blank">
                  <div>
                    <v-icon light class="mr-3">fa-user</v-icon>
                    {{ $t("My Account") }}
                    <v-icon light class="float-right">fa-sign-out-alt</v-icon>
                  </div>
                </a>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="menu-link" v-if="externalLink">
            <v-list-item-content>
              <v-list-item-title>
                <a class="no-decoration text--text mr-5" :href="externalLink.url" target="_blank">
                  <div>
                    {{ $t(externalLink.name) }}
                    <v-icon light class="float-right">fa-sign-out-alt</v-icon>
                  </div>
                </a>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="langSwitcher" class="menu-link">
            <v-list-item-content>
              <v-list-item-title>
                <div class="language-switcher" @click="screenChange++">
                  <span>{{ languageName }}</span>
                  <v-icon light size="20" class="float-right pr-1">fas fa-arrow-right</v-icon>
                </div>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!supportAccess" class="menu-link">
            <v-list-item-content>
              <v-list-item-title>
                <a id="logout" class="float-right mr-5" @click="logout">{{ $t("Logout") }}</a>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-carousel-item>
      <v-carousel-item>
        <v-list class="pa-2 myaccount-list" width="300">
          <v-row @click="screenChange--" class="language-list-tittle">
            <v-col cols="2" class="d-flex pl-5">
              <v-icon> fas fa-arrow-left</v-icon>
            </v-col>
            <v-col cols="10" class="pl-1">
              <v-list-item-title>{{ $t("Choose your language") }}</v-list-item-title>
            </v-col>
          </v-row>

          <v-list-item class="pl-3" v-for="lang in languages" :key="lang.code" @click="selectLanguage(lang.code)">
            <v-container class="pa-0">
              <v-row align="center">
                <v-col class="py-0" cols="12">
                  <span >{{ lang.name }}</span>
                </v-col>
              </v-row>
            </v-container>
          </v-list-item>
        </v-list>
      </v-carousel-item>
    </v-carousel>
  </v-menu>
</template>

<script>
import { getConfiguration } from "../../service/main";
import Theme from "../../service/themes";
import locale from "../../service/languageLoader";

export default {
  name: "MyAccountMenu",
  props: [
    "langSwitcher", 
    "showMyAccount", 
    "showUserIcon", 
    "externalLink", 
    "additionalData",
    "supportAccess",
    "name",
    "email"
  ],
  data() {
    return {
      showSettings: false,
      showList: false,
      languages: locale.info,
      screenChange: 0,
    };
  },
  computed: {
    config() {
      return getConfiguration();
    },
    themeName() {
      return config.hasOwnProperty("theme") ? config.theme : "Cameramanager";
    },
    theme() {
      return new Theme(this.themeName);
    },
    links() {
      return this.theme.links();
    },
    firstLetter() {
      return this.name ? this.name.charAt(0).toUpperCase() : null;
    },
    myAccountURL() {
      return this.links.myaccount ? this.links.myaccount : this.config.myaccountURL;
    },

    languageName() {
      const code = this.$locale.getCurrentLanguage();
      const languages = Object.values(this.languages);
      for (let i = 0; i < languages.length; i++) {
        const lang = languages[i];
        if (lang.code === code) {
          return lang.name;
        }
      }
      return null;
    },
  },
  methods: {
    logout() {
      this.$emit("logout");
    },
    selectLanguage(code) {
      this.screenChange--;
      this.$locale.setLanguage(code);
      if (this.$ga !== undefined) {
        this.$ga.set("language", code);
        this.$ga.event("Language", "Set new language", code);
      }
      this.loadCrowdin(code);
      this.showList = false;
    },
 
    loadCrowdin(currentLanguage) {
      if (this.config.crowdinIntegration && currentLanguage === "aa") {
        window._jipt = [];
        window._jipt.push(["project", "CameraManager"]);
        let scr = document.createElement("script");
        scr.src = "//cdn.crowdin.com/jipt/jipt.js";
        scr.setAttribute("id", "crowdin-script");
        document.getElementsByTagName("head")[0].appendChild(scr);
      } else {
        let el = document.getElementById("crowdin-script");
        if (el) {
          el.parentNode.removeChild(el);
          location.reload();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/main";

.avatar {
  cursor: pointer;
  background-color: var(--v-primary-darken1);
}
.no-decoration {
  text-decoration: none;
}
.menu-link {
  min-height: 0px !important;
  height: 40px !important;
  padding: 25px 20px;
}
.boldText {
  font-weight: bold;
}
.myaccount-list {
  background: white;
}


.language-switcher {
  cursor: pointer;
}
.language-list-tittle {
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
.dropdown {
  margin-right: 10px;
  align-items: center;
}
.dropdown .option {
  width: 120px;
}
a.dropdown-item {
  display: flex;
}
.lang-icon {
  width: 32px;
  margin-right: 5px;
}
.lang-name {
  color: $color-action;
}
a.dropdown-item .lang-name {
  padding-top: 7px;
  padding-left: 5px;
}
.language-list {
  background-color: white !important;
}
.dropdown-menu {
  z-index: 1001;
}
.carousel {
  background: white;
}
</style>
